const overlay = () => document.getElementById('loading-overlay');
const textEl = () => document.getElementById('loading-text');

export function showSpinner(message: string): void {
  const t = textEl();
  if (t) t.textContent = message;
  overlay()?.classList.remove('hidden');
}

export function hideSpinner(): void {
  overlay()?.classList.add('hidden');
}
